// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_tech_benefits_heading = /** @type {(inputs: {}) => string} */ () => {
	return `Six things you'll feel.`
};

const el_tech_benefits_heading = /** @type {(inputs: {}) => string} */ () => {
	return `Έξι πράγματα που θα νιώσετε.`
};

const ru_tech_benefits_heading = /** @type {(inputs: {}) => string} */ () => {
	return `Шесть ощущений, которые вы почувствуете.`
};

const he_tech_benefits_heading = /** @type {(inputs: {}) => string} */ () => {
	return `שישה דברים שתרגישו.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tech_benefits_heading = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tech_benefits_heading(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("tech_benefits_heading", locale)
	if (locale === "en") return en_tech_benefits_heading(inputs)
	if (locale === "el") return el_tech_benefits_heading(inputs)
	if (locale === "ru") return ru_tech_benefits_heading(inputs)
	if (locale === "he") return he_tech_benefits_heading(inputs)
	return "tech_benefits_heading"
};